/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Default_Catch_Boundary_Details_LabelInputs */

const en_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error details`)
};

const de_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerdetails`)
};

const pt_br2_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do erro`)
};

const tr_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata ayrıntıları`)
};

const zh_cn2_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误详情`)
};

const zh_hk2_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`錯誤詳情`)
};

const ko_kr2_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오류 세부 정보`)
};

const ru_ru2_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали ошибки`)
};

const es_419_components_default_catch_boundary_details_label = /** @type {(inputs: Components_Default_Catch_Boundary_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del error`)
};

/**
* | output |
* | --- |
* | "Error details" |
*
* @param {Components_Default_Catch_Boundary_Details_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_default_catch_boundary_details_label = /** @type {((inputs?: Components_Default_Catch_Boundary_Details_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Default_Catch_Boundary_Details_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_default_catch_boundary_details_label(inputs)
	if (locale === "de") return de_components_default_catch_boundary_details_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_default_catch_boundary_details_label(inputs)
	if (locale === "tr") return tr_components_default_catch_boundary_details_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_default_catch_boundary_details_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_default_catch_boundary_details_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_default_catch_boundary_details_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_default_catch_boundary_details_label(inputs)
	return es_419_components_default_catch_boundary_details_label(inputs)
});